import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import { DropDownChonHuongXuLyLanhDao, DropDownChonDonViChuTri } from 'components/tt-forms';
import { DatePicker, TextArea, DropDownMultipleSelect } from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import {ContainerFileDinhKem} from 'components/upload';
import { DuLieuHeThong } from 'api';

class KetQuaTiepCongDan extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      require: false,
      huongXuLy: 'GIAI_QUYET_NGAY',
      ghiChuXuLy: '',
      // CHO_GIAI_QUYET
      donViChuTriId: '',
      donViPhoiHopId: [],
      thoiHan: '',
      dataDonViPhoiHop: [],
      dsTepDinhKemInput: [],
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      showTableUpload: false,
      donViChuTri: this.props.donViChuTri
    }
  }

  componentDidMount() {
    if (this.state.dsTepDinhKemInput.length == 0) {
      let item = {
        taiLieuVanThuId: '',
        ten: 'Văn bản thông báo kết luận',
        required: true,
        tenFile: '',
        duongDan: '',
        ngayQuyetDinh: '',
        soQuyetDinh: '',
        loaiTepDinhKem: 'QUYET_DINH'
      };
      this.state.dsTepDinhKemInput.push(item);
      this.state.dsTepDinhKem.push(item);
      this.props.onInit(this.state);
    }
    if (this.props.type == 'dot-xuat-them-moi') {
      this.setState({showTableUpload: true});
    }
    if(this.props.donViChuTri.length == 0) {
      DuLieuHeThong.actions.getDonViChuTri.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViChuTri',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  handleChange(name, e) {
    if (name == 'donViPhoiHopId') {
      this.state.donViPhoiHopId = e;
    } else {
      this.state[name] = e.target.value;
    }
    if (name == 'huongXuLy') {
      this.state.ghiChuXuLy = '';
    }
    if (name == 'donViChuTriId') {
      this.state.dataDonViPhoiHop = [];
      this.state.donViPhoiHopId = [];
      if (e.target.value != '') {
        this.state.donViChuTri.map((item) => {
          if (item.coQuanQuanLyId != e.target.value) {
            this.state.dataDonViPhoiHop.push({value: item.coQuanQuanLyId, label: item.ten});
          }
        });
      }
    }

    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onChangeItem(data, index) {
    this.state.dsTepDinhKem[index] = data;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.searching != nextProps.searching) {
      this.setState({
        searching: nextProps.searching
      });

      this.setState({
        doSearch: nextProps.searching
      })
    }

    if (nextProps.soTiepCongDan != this.props.soTiepCongDan) {
      let data = nextProps.soTiepCongDan;
      this.state.huongXuLy = data.huongGiaiQuyetTCDLanhDao == 'KHOI_TAO' ? 'GIAI_QUYET_NGAY' : data.huongGiaiQuyetTCDLanhDao;
      this.state.ghiChuXuLy = data.yKienXuLy;
      if (data.huongGiaiQuyetTCDLanhDao == 'CHO_GIAI_QUYET') {
        this.state.donViChuTriId = data.donViChuTriInfo ? data.donViChuTriInfo.coQuanQuanLyId : '';
        if (data.danhSachDonViPhoiHops) {
          data.danhSachDonViPhoiHops.map((item) => {
            this.state.donViPhoiHopId.push({value: item.coQuanQuanLyId, label: item.ten});
          });
        }
        this.state.thoiHan = data.ngayBaoCaoKetQua ? moment(data.ngayBaoCaoKetQua) : '';
      }

      data.listTaiLieuVanThu.map((item, i) => {
        this.state.dsTepDinhKemInput[i] = this.state.dsTepDinhKem[i] = {
          taiLieuVanThuId: item.taiLieuVanThuId,
          ten: item.ten,
          tenFile: item.tenFile,
          required: item.required || false,
          duongDan: item.duongDan,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh) : '',
          soQuyetDinh: item.soQuyetDinh || '',
          loaiTepDinhKem: item.loaiTepDinhKem
        };
      });
      this.state.showTableUpload = true;
      this.state.donViChuTri.map((item) => {
        if (item.coQuanQuanLyId != this.state.donViChuTriId) {
          this.state.dataDonViPhoiHop.push({value: item.coQuanQuanLyId, label: item.ten});
        }
      });

      this.setState({...this.state});
      this.props.onInit(this.state);
    }
    if (nextProps.donViChuTri != this.props.donViChuTri) {
      this.state.donViChuTri = nextProps.donViChuTri;
      this.setState({...this.state})
    }
  }

  onFileRemove(id, data) {
    this.state.dsTepDinhKemRemove = [
      ...this.state.dsTepDinhKemRemove,
      id
    ];
    this.state.dsTepDinhKem = data;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onFileChange(data) {
    this.state.dsTepDinhKem = data;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.setState({...newData});
    this.props.onChange(newData);
  }

  render() {
    return (
      <div className="box-items mb0-18">
        <div className="box-forward">
          <div className="container-box">
            <div className="group-box">
              <div className="title">
                <div className="rows">
                  <div className="col-12 mt15">
                    <h3>Thông tin xử lý lượt tiếp công dân</h3>
                  </div>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <DropDownChonHuongXuLyLanhDao selected={this.state.huongXuLy} onChange={this.handleChange.bind(this, 'huongXuLy')} name="dropdownChonHuongXuLyLanhDao"/>
                </div>
                <ShowIf condition={this.state.huongXuLy != ''}>
                  <div className="rows">
                    <TextArea label="Ý kiến xử lý" rows={3}  maxLength={9999} value={this.state.ghiChuXuLy} onChange={this.handleChange.bind(this, 'ghiChuXuLy')} name="textareaYKienXuLy"/>
                  </div>
                  <div className="rows">
                    <ShowIf condition={this.state.huongXuLy == 'CHO_GIAI_QUYET'}>
                      <DropDownChonDonViChuTri bindValidator={this} selectedValue={this.state.donViChuTriId} except={this.state.donViPhoiHopId} label="Đơn vị chủ trì" onChange={this.handleChange.bind(this, 'donViChuTriId')} require name="dropdownDonViChuTri"/>
                      <DropDownMultipleSelect name="dropdownDonViPhoiHop" className="col-25" label="Đơn vị phối hợp" options={this.state.dataDonViPhoiHop} placeholder={{key: '', text: '--Chọn--'}} value={this.state.donViPhoiHopId} onChange={this.handleChange.bind(this, 'donViPhoiHopId')}/>
                      <DatePicker label='Hạn xử lý' require bindValidator={this} channel="formTaoDon" startDate={moment(new Date())} value={this.state.thoiHan} onChange={this.handleChangeDate.bind(this, 'thoiHan')}  name="datepickerHanXuLy"/>
                    </ShowIf>
                  </div>
                  {
                    this.state.showTableUpload ?
                      <div className="items-form container-filedinhkem">
                        <div className="rows">
                          <div className="col-12">
                            <ContainerFileDinhKem label="Danh sách văn bản xử lý" reload={true} bindValidator={this} data={this.state.dsTepDinhKemInput} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} name="fileDinhKemTCDDinhKy" onSave={this.props.onSave}/>
                          </div>
                        </div>
                      </div>
                    :''
                  }
                </ShowIf>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

KetQuaTiepCongDan.defaultProps = {
  yKienCheck: false,
  isValid: false,
  donViChuTri: [],
  lyDoList: [],
  onSave: false,
  type: ''
}

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    donViChuTri: state.duLieuHeThong.donViChuTri
  };
}
export default connect(bindStateToProps)(validatable(KetQuaTiepCongDan));



// WEBPACK FOOTER //
// ./src/components/modules/reception/KetQuaTiepCongDan.jsx